import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageTransion from "../Componinets/PageTransion";
import Product from "../Componinets/Slideproduct/Product";
import SlideProductLoading from "../Componinets/Slideproduct/SlideProductLoading";

function SerashResults() {
  let [result, setResult] = useState([]);
  let [Loading, setloading] = useState(true);
  let query = new URLSearchParams(useLocation().search).get("query");
  console.log(result);

  useEffect(() => {
    let featchResults = async () => {
      try {
        let res = await fetch(
          `https://dummyjson.com/products/search?q=${query}`
        );
        let data = await res.json();
        setResult(data.products || []);
      } catch (error) {
        console.error("SearshError", error);
      } finally {
        setloading(false);
      }
    };
    if (query) featchResults();
  }, [query]);

  return (
    <PageTransion key={query}>
      <div className="category_Prodicts">
        {Loading ? (
          <SlideProductLoading key={query} />
        ) : result.length > 0 ? (
          <div className="Container">
            <div className="top_slide">
              <h2>Result for : {query}</h2>
            </div>
            <div className="Prodicts">
              {result.map((item, index) => (
                <Product item={item} key={index} />
              ))}
            </div>
          </div>
        ) : (
          <div className="Container">
            <p>No Result Found .</p>
          </div>
        )}
      </div>
    </PageTransion>
  );
}

export default SerashResults;
